import EL, { HTMLELEMENT } from '../../EL/EL.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
import Translatable from '../../../interface/Translatable.js';
// Model Structure
export const bodyAttr = makeAttrStruct([
    ['class']
]);
export const bodyData = makeDataStruct();
export const bodyModel = makeStruct([
    ['attributes', bodyAttr],
    ['data', bodyData]
]);
// Simplified Model
export function body(className) {
    return {
        attributes: bodyAttr(className),
        data: bodyData()
    };
}
/** A BODY Element */
export default class BODY extends EL {
    constructor(model) {
        super(document.body, HTMLELEMENT.BODY, model);
        // console.log('BODY Model:', model);
        this.implement(new Translatable(this));
        if (model.attributes.class) {
            this.el.setAttribute('class', model.attributes.class);
        }
    }
    createElement() {
        const element = document.body;
        element.className = this.className;
        return element;
    }
    makeElement(model) {
        const el = this.createElement();
        this.el = el;
        //this.merge(model);
        return el;
    }
    merge(model) { }
}
export { EL };
